export default __webpack_public_path__ + "static/home-e3661217f6e22d8fe4d6e25657b24bee.png";